import React, {useContext, useEffect, useState} from 'react';
import {Context} from "../../index";
import {getPollItemsCurrentUser, updatePoolItem} from "../../http/poolAPI";
import {Image} from "react-bootstrap";
import {toast} from "react-toastify";
import {addUserLog} from "../../http/userLogAPI";
import {
    check,
    updateUserVirtBalancePollDoneApi
} from "../../http/userAPI";
import {useNavigate} from "react-router-dom";
import {POLL_LIBRARY_ROUTE} from "../../utils/consts";
import PollsPhotoZoom from "../modals/polls/PollsPhotoZoom";

const PoolItemFull = ({pollitem, setActiveComponent}) => {
    const { user, poolStore } = useContext(Context);
    const [expandedStates, setExpandedStates] = React.useState({});
    const [surveyData, setSurveyData] = useState(
        Array.from({ length: 8 }, () => ({
            rating: null, // или 0, в зависимости от требований
            text: '',
            error: false,
        }))
    );
    const navigate = useNavigate();
    const [winner, setWinner] = useState(null);
    const [loading, setLoading] = useState(false);
    const [hoveredItem, setHoveredItem] = useState(null);
    const [showZoom, setShowZoom] = useState(false);
    const [zoomedImage, setZoomedImage] = useState(null);


    const activeItemsCount = Array.from({ length: 8 }).filter((_, i) =>
        poolStore?.selectedPoolItem?.pool?.[`pool_item${i + 1}_flag`]
    ).length;

    const pollTypeLabels = {
        'COVER_POLL': 'Cover Poll',
        'TITLE_POLL': 'Title Poll',
        'COVER_TITLE_POLL': 'Cover & Title Poll',
        'DESCRIPTION_POLL': 'Description Poll',
        'MIXED_POLL': 'Mixed Poll',
    };

    useEffect(() => {
        setSurveyData(
            Array.from({ length: 8 }, () => ({
                rating: null,
                text: '',
                error: false,
            }))
        );
        setWinner(null);
    }, [poolStore?.selectedPoolItem?.id]);

    useEffect(() => {
        if (poolStore?.poolitems.length && poolStore?.selectedPoolItem?.id) {
            const updatedSelected = poolStore?.poolitems?.find(item => item.id === poolStore?.selectedPoolItem.id);
            if (updatedSelected) {
                poolStore?.setSelectedPoolItem(updatedSelected);
            }
        }
    }, [poolStore?.poolitems, poolStore]);


    const editPollItemWhenMakeSurvey = async () => {

       if (!winner) {
           toast.error(`Please select a Winner.`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
       }
        for (let i = 0; i < activeItemsCount; i++) {
            const option = surveyData[i];
            if (!option.text) {
                toast.error(`Write comment for option #${i + 1}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                return;
            }
            if (option.error) {
                toast.error(`Min 30 characters required #${i + 1}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                return;
            }
            if (!option.rating) {
                toast.error(`Rate option #${i + 1}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                return;
            }

        }

        try {
            setLoading(true);
            const updatedItem = {
                itemId: poolStore?.selectedPoolItem?.id,
                winner: winner,
            };
            // Добавим поля pool_itemN_rating и pool_itemN_text
            surveyData.forEach((item, index) => {
                const num = index + 1;
                updatedItem[`pool_item${num}_rating`] = item.rating;
                updatedItem[`pool_item${num}_text`] = item.text;
            });
            await updatePoolItem(updatedItem);
            const updateUserData = await updateUserVirtBalancePollDoneApi(user?.user?.id, poolStore?.selectedPoolItem?.id);
            const data = await check();
            user.setUser(data);
            toast.info(updateUserData.message, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            toast.info(updateUserData.newBalance, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

            if (user?.user?.id) {
                getPollItemsCurrentUser(user.user.id)
                    .then((data) => {
                        poolStore.setCurrentUserPoolItems(data);
                    })
                    .catch((err) => console.error("❌ Error:", err));
            }

            setSurveyData(
                Array.from({ length: 8 }, () => ({
                    rating: null,
                    text: '',
                    error: false,
                }))
            );
            setWinner(null);


            setTimeout(() => {
            // Найти обновлённый объект по id
            const updatedSelected = poolStore.currentUserPoolItems.find(item => item.id === poolStore?.selectedPoolItem?.id);
            if (updatedSelected) {
                poolStore.setSelectedPoolItem(updatedSelected);
            }
                setLoading(false);
            }, 2000);

        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Something went wrong';
            toast.error(errorMessage, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            setLoading(false);
        }
    };


    const surveyIsReady = () => {
        editPollItemWhenMakeSurvey();
    };

    const cancelSurvey = async () => {
        try {
            setLoading(true);
            const updatedItem = {
                itemId: poolStore?.selectedPoolItem?.id,
                respondent_step: "STEP0",
                respondent_id: null,
                respondentId: null,
                respondent_name: null,
                start_date: null,
                end_date: null,
                winner: null,
            };
            await updatePoolItem(updatedItem);

            const pollLabel = pollTypeLabels[poolStore?.selectedPoolItem?.pool?.pool_type] || 'Unknown Poll';
            await addUserLog(
                user?.user?.id,
                0, user?.user?.balance,
                "Cancel Poll",
                `You cancel a ${pollLabel} #${poolStore?.selectedPoolItem?.pool?.id}-${poolStore?.selectedPoolItem?.id}. No matter why, just choose another one.`,
                user?.user?.level_of_trust,
                user?.user?.amz_name,
                user?.user?.audible_name,
                user?.user?.email,
                `User cancel PollItem ID: ${pollitem?.id}`,
                Math.floor(new Date().getTime() / 1000),
                `Poll Item ID: ${pollitem?.id} is canceled by Respondent ID: ${user?.user?.id}`,
                null,null, null, null, null, null, null, pollitem?.pool?.id, pollitem?.id,

            );

            toast.info(`Poll canceled. Choose another one.`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

            if (user?.user?.id) {
                getPollItemsCurrentUser(user.user.id)
                    .then((data) => {
                        poolStore.setCurrentUserPoolItems(data);
                    })
                    .catch((err) => console.error("❌ Error:", err));
            }
            setLoading(false);
            poolStore?.setSelectedPoolItem({});
           //user?.setActiveComponent('MainPageDashboard');
           navigate(POLL_LIBRARY_ROUTE);
        } catch (error) {
            console.error("Error updating poll item:", error);
            alert("An error occurred while updating the poll item. Please try again later.");
        }
    };

    const getColClass = () => {
        const count = activeFlags.length;
        if (count <= 2) return 'col-3';
        if (count === 3) return 'col-3';
        return 'col-3'; // 4 и больше
    };

    const activeFlags = [1, 2, 3, 4, 5, 6, 7, 8].filter(
        (num) => poolStore?.selectedPoolItem?.pool?.[`pool_item${num}_flag`]
    );

    const handleToggleDescription = (num) => {
        setExpandedStates((prevState) => ({
            ...prevState,
            [num]: !prevState[num], // Переключаем состояние (открыто/закрыто) для конкретного элемента
        }));
    };

    const renderStars = (itemIndex) => {
        const currentRating = surveyData[itemIndex]?.rating || 0;

        return (
            <div className="d-flex mt-0 justify-content-center align-items-center">
                {[...Array(5)].map((_, index) => (
                    <i
                        key={index}
                        className={`bi ${index < currentRating ? "bi-star-fill" : "bi-star"}`}
                        style={{
                            color: index < currentRating ? "gold" : "lightgray",
                            fontSize: "24px",
                            cursor: "pointer",
                            marginRight: "6px"
                        }}
                        onClick={() => handleStarClick(itemIndex, index)}
                    ></i>
                ))}
            </div>
        );
    };



    const handleStarClick = (itemIndex, starIndex) => {
        const updated = [...surveyData];
        updated[itemIndex].rating = starIndex + 1;
        setSurveyData(updated);
    };



    return (
        <div>
            <div className="card text-center align-content-center shadow-sm mt-2 mb-0 p-3" style={{ width: '100%' }}>
                <div className="p-2">
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 mt-0 mb-2">
                        <h5 className="text-start text-muted fst-italic fw-bold text-danger m-0">
                            {poolStore?.selectedPoolItem?.respondent_step === 'STEP2' ? (
                                'This Poll is Completed'
                            ) : (
                                (() => {
                                    const item = poolStore?.selectedPoolItem;
                                    const now = Math.floor(Date.now() / 60000);
                                    const passedMinutes = now - item?.start_date;
                                    const remaining = item?.time_to_answer - passedMinutes;

                                    if (!item?.start_date) return 'This Poll is in Progress... (Just Started)';
                                    if (remaining <= 0) return 'This Poll is in Progress... (Expired)';

                                    const hours = Math.floor(remaining / 60);
                                    const minutes = remaining % 60;

                                    return `This Poll is in Progress... (${hours}h ${minutes}m left)`;
                                })()
                            )}
                        </h5>

                        <div className="d-flex flex-column flex-sm-row gap-2 justify-content-md-end w-50 w-md-auto">
                            <button
                                type="button"
                                className="btn btn-secondary btn-sm w-md-auto"
                                onClick={() => cancelSurvey()}
                                disabled={poolStore?.selectedPoolItem?.respondent_step === 'STEP2' || loading}
                            >
                                Cancel Poll
                            </button>
                            <button
                                type="button"
                                className="btn btn-success btn-sm w-md-auto"
                                onClick={() => surveyIsReady()}
                                style={{
                                    transition: "transform 0.2s",
                                    transform: hoveredItem === 30 ? "scale(1.05)" : "scale(1)",
                                }}
                                onMouseEnter={() => setHoveredItem(30)}
                                onMouseLeave={() => setHoveredItem(null)}
                                disabled={poolStore?.selectedPoolItem?.respondent_step === 'STEP2' || loading}
                            >
                                Send Poll
                            </button>
                        </div>
                    </div>


                    <h6 className="text-start text-muted fst-italic mb-2" style={{ lineHeight: '1.4' }}>
                        <div><strong>Name of Poll:</strong> {poolStore?.selectedPoolItem?.pool?.name}</div>
                        <div><strong>Language:</strong> {poolStore?.selectedPoolItem?.pool?.language || 'No language available.'}</div>
                        <div>
                            <strong>Created by:</strong> {poolStore?.selectedPoolItem?.pool?.owner || 'No owner available.'} on{" "}
                            {poolStore?.selectedPoolItem?.pool?.createdAt
                                ? new Date(poolStore.selectedPoolItem?.pool?.createdAt).toLocaleDateString('en-GB', {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric'
                                })
                                : 'No creation date available.'
                            }
                        </div>
                    </h6>

                    <div className="text-start text-muted fst-italic mb-2" style={{ fontSize: '0.9rem', lineHeight: '1.5' }}>
                        <div>
                            <strong>Poll Question:</strong> "{poolStore?.selectedPoolItem?.pool?.question || 'No question available.'}"
                        </div>
                        <div>
                            {poolStore?.selectedPoolItem?.respondent_step === 'STEP2' ? (
                                <>Earned: <strong className="text-danger">{poolStore?.selectedPoolItem?.pool?.default_price || 50} Virt</strong> has been successfully credited to your account</>
                            ) : (
                                <>Earnings: <strong className="text-danger">{poolStore?.selectedPoolItem?.pool?.default_price || 50} Virt</strong> upon completion (Postpaid)</>
                            )}
                        </div>
                    </div>
                </div>



                <div className="row">
                    {activeFlags.map((num, index) => (
                        <div key={num} className="col-12 col-sm-6 col-md-3 p-2">
                            <div className={`card shadow-sm p-3 d-flex flex-column justify-content-start align-items-start ${winner === num ? 'border border-success border-2' : ''}`}>

                                <p className="mb-2 fw-bold small text-muted text-start">
                                    <strong className="text-danger">
                                        {(poolStore?.selectedPoolItem?.respondent_step === 'STEP2' && Number(poolStore?.selectedPoolItem?.winner) === num) && 'Winner '}
                                    </strong>
                                    Option #{num}
                                </p>

                                <div className="d-flex flex-column w-100 mb-2">
                                    <button
                                        className={`btn btn-sm ${winner === num ? 'btn-success' : 'btn-outline-success'}`}
                                        style={{
                                            transition: "transform 0.2s",
                                            transform: hoveredItem === num ? "scale(1.05)" : "scale(1)",
                                        }}
                                        onMouseEnter={() => setHoveredItem(num)}
                                        onMouseLeave={() => setHoveredItem(null)}
                                        onClick={() => setWinner(num)}
                                        disabled={poolStore?.selectedPoolItem?.respondent_step === 'STEP2' || loading}
                                        type="button"
                                    >
                                        {winner === num ? (<strong>WINNER</strong>) : 'Set as Winner'}
                                    </button>

                                    <strong className="text-start text-muted small fst-italic mt-3">
                                        {poolStore?.selectedPoolItem?.respondent_step === 'STEP2' ? 'You write comment:' : 'Write your comment below:'}
                                    </strong>

                                    {poolStore?.selectedPoolItem?.respondent_step === 'STEP2' ? (
                                        <span className="text-start text-muted small fst-italic">{poolStore?.selectedPoolItem?.[`pool_item${num}_text`] || surveyData[index]?.text}</span>
                                    ) : (
                                        <>
                                            <form className="mt-2 w-100">
                                <textarea
                                    rows={2}
                                    className="form-control form-control-sm border border-secondary rounded"
                                    value={surveyData[index]?.text}
                                    onChange={e => {
                                        const newText = e.target.value;
                                        const updatedItems = [...surveyData];
                                        updatedItems[index].text = newText;
                                        updatedItems[index].error = newText?.trim().length < 30;
                                        setSurveyData(updatedItems);
                                        e.target.style.height = "auto";
                                        e.target.style.height = e.target.scrollHeight + "px";
                                    }}
                                    placeholder="Answer and write short comment here..."
                                    disabled={loading}
                                    style={{
                                        fontSize: '0.875rem',
                                        minHeight: '30px',
                                        resize: 'none',
                                        overflow: 'hidden',
                                        width: '100%',
                                    }}
                                />
                                            </form>
                                            {(surveyData[index]?.text?.length < 30 && surveyData[index]?.text?.length > 3) && (
                                                <div className="text-danger small text-start">Minimum 30 characters required</div>
                                            )}
                                        </>
                                    )}

                                    <strong className="text-start text-muted small fst-italic mt-3 mb-1">
                                        {poolStore?.selectedPoolItem?.respondent_step === 'STEP2'
                                            ? `Your rating is ${poolStore?.selectedPoolItem?.[`pool_item${num}_rating`]} stars.`
                                            : 'Rate this option:'}
                                    </strong>

                                    <span className="d-flex align-items-center flex-wrap mb-2">
                        {poolStore?.selectedPoolItem?.respondent_step === 'STEP2'
                            ? [...Array(5)].map((_, starIndex) => {
                                const rating = poolStore?.selectedPoolItem?.[`pool_item${num}_rating`] || 0;
                                return (
                                    <i
                                        key={starIndex}
                                        className={`bi bi-star${starIndex < rating ? '-fill' : ''}`}
                                        style={{
                                            color: starIndex < rating ? 'gold' : 'lightgray',
                                            fontSize: '20px',
                                            marginRight: '6px',
                                        }}
                                    />
                                );
                            })
                            : renderStars(num - 1)}
                    </span>
                                </div>

                                {/* Cover image (if applicable) */}
                                {(poolStore?.selectedPoolItem?.pool?.pool_type.includes('COVER')) && (
                                    <div
                                        onClick={() => {
                                            const imageUrl = poolStore?.selectedPoolItem?.pool?.[`pool_item${num}_image`]
                                                ? `${process.env.REACT_APP_API_URL}pools/${poolStore?.selectedPoolItem?.pool?.[`pool_item${num}_image`]}`
                                                : `${process.env.REACT_APP_API_URL}covers/empty-cover.jpg`;
                                            setZoomedImage(imageUrl);
                                            setShowZoom(true);
                                        }}
                                        className="w-100 text-center"
                                        style={{ cursor: 'zoom-in', textAlign: 'center' }}
                                    >
                                    <Image
                                        src={
                                            poolStore?.selectedPoolItem?.pool?.[`pool_item${num}_image`]
                                                ? `${process.env.REACT_APP_API_URL}pools/${poolStore?.selectedPoolItem?.pool?.[`pool_item${num}_image`]}`
                                                : `${process.env.REACT_APP_API_URL}covers/empty-cover.jpg`
                                        }
                                        alt={`Poll Item ${num}`}
                                        style={{
                                            width: '100%',
                                            maxWidth: '300px',
                                            display: 'block',
                                            marginLeft: 'auto',
                                            marginRight: 'auto',
                                            objectFit: 'cover',
                                            borderRadius: '8px'
                                        }}
                                        className="shadow mb-2"
                                    />
                                    </div>
                                )}

                                {/* Title & author */}
                                {(poolStore?.selectedPoolItem?.pool?.pool_type.includes('TITLE')) && (
                                    <>
                                        <h6 className="fw-bold text-muted mb-1" style={{ fontSize: '0.85rem' }}>
                                            {poolStore?.selectedPoolItem?.pool?.[`pool_item${num}_title`] || 'Untitled'}
                                        </h6>
                                        <p className="text-muted mb-1" style={{ fontSize: '0.75rem' }}>
                                            by {poolStore?.selectedPoolItem?.pool?.[`pool_item${num}_pn`] || 'Unknown Author'} (Author)
                                        </p>
                                    </>
                                )}

                                {/* Description block */}
                                {(poolStore?.selectedPoolItem?.pool?.pool_type.includes('DESCRIPTION')) && (() => {
                                    const description = poolStore?.selectedPoolItem?.pool?.[`pool_item${num}_desc`] || 'No description available.';
                                    const isLong = description.length > 190;
                                    const shortDescription = description.slice(0, 190);
                                    const expanded = expandedStates[num] || false;

                                    return (
                                        <p className="text-secondary mb-0 text-start" style={{ fontSize: '0.8rem' }}>
                                            {expanded ? description : shortDescription}
                                            {isLong && (
                                                <span
                                                    onClick={() => handleToggleDescription(num)}
                                                    className="text-primary"
                                                    style={{ cursor: 'pointer', marginLeft: '5px' }}
                                                >
                                    {expanded ? 'Show less' : 'Read more...'}
                                </span>
                                            )}
                                        </p>
                                    );
                                })()}
                            </div>
                        </div>
                    ))}
                </div>


                <div className="d-flex align-items-end gap-3 ms-auto me-2 mt-3 mb-2">
                    <button
                        type="button"
                        className="btn btn-sm btn-secondary"
                        onClick={() => cancelSurvey()}
                        disabled={poolStore?.selectedPoolItem?.respondent_step === 'STEP2' || loading}
                    >
                        Cancel Poll
                    </button>
                    <button
                        type="button"
                        className="btn btn-sm btn-success"
                        onClick={() => surveyIsReady()}
                        style={{
                            transition: "transform 0.2s",
                            transform: hoveredItem === 30 ? "scale(1.1)" : "scale(1)",
                        }}
                        onMouseEnter={() => setHoveredItem(30)}
                        onMouseLeave={() => setHoveredItem(null)}
                        disabled={poolStore?.selectedPoolItem?.respondent_step === 'STEP2' || loading}
                    >
                        Send Poll
                    </button>
                </div>
            </div>
            <PollsPhotoZoom
                show={showZoom}
                onClose={() => setShowZoom(false)}
                photo={zoomedImage}


            />
            </div>
    );
};

export default PoolItemFull;